import { gql } from '@apollo/client'

export const GET_USER_STORES = gql`
  query GetUserStores($input: UserCompanyStoresInput!) {
    userStores(input: $input) {
      id
    }
  }
`
